'use strict';

define('components/nav/navigation.vehicles',[
  'jquery',
  'Handlebars',
  'lib/page-cache',
  './navigation',
  'lib/ucFirst',
  'txt!./vehicles-loader.part.hbs',
  'txt!./vehicles-carousel.part.hbs',
  'txt!./vehicles-container.part.hbs',
  'txt!./vehicles-series.part.hbs',
  'lib/util/tda.config',
  'lib/services/lscs',
  'disclaimers',
  'lib/analytics/blocks/index',

  // Side effect includes
  'lazyload',
  'lib/loader/series',
  'lib/transforms/series.byCategory',
  'lib/transforms/series.latest',
  'lib/helpers/concat',
  'lib/helpers/disclaimerMpg',
  'lib/helpers/disclaimer',
  'lib/helpers/data-attr',
  'lib/helpers/monetize',
  'bxSlider'
], function (
  $,
  Handlebars,
  PageCache,
  Navigation,
  ucFirst,
  txtLoader,
  txtCarousel,
  txtContainer,
  txtSeries,
  tdaConfig,
  lscs,
  disclaimers,
  blocks
) {
  // This is a plugin for the navigation to handle the vehicles menu
  var CarouselMode = 'carousel';
  var CompareSource = '';
  var ContainerMode = 'container';

  var __tmplLoader = Handlebars.compile(txtLoader);
  var __tmplCarousel = Handlebars.compile(txtCarousel);
  var __tmplContainer = Handlebars.compile(txtContainer);

  // Series display names seem to include markdown of some nature
  var __italicsRegex = /_(.*?)_/g;
  function __formatDisplayName(name) {
    var displayName = name.replace(__italicsRegex, function (match, p1) {
      return '<i>' + p1 + '</i>';
    });
    return ucFirst(displayName);
  }

  function __transformCompareDcr(data) {
    var seriesHash = {};
    $(data).find('Vehicle').each(function () {
      var seriesString = $(this).find('series').text();
      var yearString = $(this).find('toyotaVehicleName').text().substring(0, 4);
      var firstCompareURLArray = $(this).find('conquestPath:first').text().split('/');
      if (firstCompareURLArray[1] === 'sites') {
        firstCompareURLArray.splice(0, 3); // Drop the first 3 items from array ('', 'sites', 'TDA')
        firstCompareURLArray.unshift('/' + tdaConfig.site.context_url);
      }
      var firstCompareURL = firstCompareURLArray.join('/'); // create URL from array
      // UPDATE HASH FOR year/series with first compare url.
      var hashKey = yearString + '-' + seriesString;
      seriesHash[hashKey] = firstCompareURL;
    });
    return seriesHash;
  }

  var VehiclesPlugin = Navigation.Plugin.extend({
    initialize: function (nav, navOpt) {
      this.options = $.extend({}, VehiclesPlugin.defaults, navOpt.vehicles);
    },

    onModelLoaded: function (model) {
      var self = this;
      var nav = this.getNavigation();

      nav.walk(function (link, path) {
        // Checking for the link with the key vehicles
        if ('vehicles' === link.key || 'mobile-vehicles' === link.key) {
          // Determine what mode we are in
          var region = nav.getPathRegion(path);
          var renderMode;

          if (false === region || 'utility' === region.key) {
            // Unknown or Utility region is rendered as a standard link
            // do nothing
            return;
          }

          if (self.options.carouselRegions.indexOf(region.key) >= 0) {
            renderMode = CarouselMode;
          } else {
            renderMode = ContainerMode;
          }

          if (renderMode) {
            link = $.extend({}, link);
            link.type = 'vehicles';
            link['data-nav-plugin'] = 'vehicles';
            link['data-rendermode'] = renderMode;
            // link['data-disabledseries'] = JSON.stringify(link.disabledSeries || []);
            link['data-disabledseries'] = JSON.stringify(BATSiteConfig.disabledVehicles || []);
            link['data-path'] = nav.pathToString(path, link);
            CompareSource = link['compareSource'];
            return link;
          }
        }
      });
    },

    onRendered: function () {
      // Based on what we found above, trigger some js
      var opt = this.options;
      var nav = this.getNavigation();
      var compareCacheId = 'series.compare.urlMap';
      var compareConfig = {};

      if (CompareSource === 'local') {
        compareConfig.path = 'templatedata/BAT/VehicleAssociation/data/LocalVehicleAssociation.xml';
        compareConfig.tda = tdaConfig.tda.code;
      } else {
        compareConfig.path = 'templatedata/BAT/VehicleAssociation/data/VehicleAssociation.xml';
        compareConfig.tda = 'WWW';
      }

      if (!PageCache.has(compareCacheId) && !PageCache.isPending(compareCacheId)) {
        PageCache.maybeSet(compareCacheId, lscs.dcr().fetch(compareConfig).then(__transformCompareDcr));
      }

      // BAT-4777 keyboard navigation for "SEE OFFERS” and “COMPARE” links
      nav.$el.on('keydown', '#nav-vehicles', this.onMenuKeyDown.bind(this, nav));
      nav.$el.on('navigationcollapsed', '.site-nav-link-type-vehicles', this.onNavigationCollapsed.bind(this, nav));

      PageCache
        .await('series.byCategory.latest')
        .then(function (categories) {
          // We have the categorized series data, fill in the placeholders
          $('[data-nav-plugin="vehicles"]', nav.$el).each(function () {
            var $el = $(this);
            var link = nav.linkByPathString($el.data('path'));
            var renderMode = $el.data('rendermode');
            var disabledSeries = $el.data('disabledseries');

            // Build the link list for the container based vehicle menu
            var categoryLinks = Object
              .keys(categories)
              .filter(function (catId) {
                if (opt.disabledCategories && opt.disabledCategories.length) {
                  return opt.disabledCategories.indexOf(catId) < 0;
                }
                return true;
              }).map(function (catId) {
                var cat = categories[catId];
                return {
                  id: 'category-' + cat.code,
                  type: 'container',
                  title: cat.name,
                  'data-relative-content-section': link.title,
                  links: cat.series
                    .filter(function (series) {
                      return disabledSeries.indexOf(series.series_code) < 0;
                    }).map(function (series, idx) {
                      var dataLayer = $.extend({}, blocks.seriesBlock(series), { content_position_element: idx + '' });
                      return {
                        id: 'series-' + series.series_code,
                        type: 'series',
                        useBookmarkLinks: link.useBookmarkLinks,
                        series: $.extend({}, series, { series_display_name: __formatDisplayName(series.series_display_name) }),
                        dataLayer: JSON.stringify(dataLayer),
                        assetUrlPrefix: opt.assetUrlPrefix,
                        'data-relative-content-section': link.title + '/' + cat.name,
                      };
                    }),
                };
              });

            if (CarouselMode === renderMode) {
              $el = $(nav.renderInContext(__tmplCarousel, { link: link, categoryLinks: categoryLinks })).replaceAll($el);
              $el.each(function () {
                var $this = $(this);
                var needsReload = true;
                var $nextSlide = $this.find('.arrow-control.next');
                var $prevSlide = $this.find('.arrow-control.prev');
                var slider;
                var isPrevNextTabEnter = false;
                var updateActive = function (idx, nSlides) {
                  $prevSlide[idx > 0 ? 'addClass' : 'removeClass']('active');
                  $nextSlide[idx < nSlides - 1 ? 'addClass' : 'removeClass']('active');
                  // BAT-4775 Keyboard Controls - Enable User to reach arrows < > (adding 2 'a' elements behind bxSlider controls)
                  if (slider) {
                    $('#site-nav-vehicles-previuos-tab a').attr('tabindex', idx > 0 ? 0 : -1);
                    $('#site-nav-vehicles-next-tab a').attr('tabindex', idx < nSlides - 1 ? 0 : -1);
                    $(slider).find('.site-nav-vehicles-slide a').attr('tabindex', -1);
                    $(slider).find('.site-nav-vehicles-slide span').attr('tabindex', -1);
                    $(slider.getCurrentSlideElement()).find('a').removeAttr('tabindex');
                    $(slider.getCurrentSlideElement()).find('span').removeAttr('tabindex');
                    if (isPrevNextTabEnter && $(slider.getCurrentSlideElement()).find('a').length > 0) {
                      setTimeout(function () {
                        $(slider.getCurrentSlideElement()).find('a')[0].focus();
                      }, 500);
                    }
                  }
                  isPrevNextTabEnter = false;
                };
                var onPrevSlideKeyUp = function (event) {
                  if (event.keyCode === 13 || event.keyCode === 32) {
                    event.preventDefault();
                    isPrevNextTabEnter = true;
                    slider.goToPrevSlide();
                  }
                };
                var onNextSlideKeyUp = function (event) {
                  if (event.keyCode === 13 || event.keyCode === 32) {
                    event.preventDefault();
                    isPrevNextTabEnter = true;
                    slider.goToNextSlide();
                  }
                };
                slider = $this.find('.site-nav-vehicles-carousel-container').bxSlider({
                  infiniteLoop: false,
                  useCSS: true,
                  pagerCustom: $this.find('.site-nav-vehicles-pager'),
                  adaptiveHeight: true,
                  waitForImageLoad: false,
                  onSliderLoad: function () {
                    setTimeout(function () {
                      // BAT-4775 Keyboard Controls - Enable User to reach arrows < > (adding 2 'a' elements behind bxSlider controls)
                      $('.site-nav-vehicles-wrap div.bx-carousel-controls div').css({ 'z-index': 10 });
                      if (!($('#site-nav-vehicles-previuos-tab').length > 0)) {
                        $('.site-nav-vehicles-wrap div.bx-wrapper').before('<div class="bx-carousel-controls" id="site-nav-vehicles-previuos-tab"><a data-linktext="previous" aria-label="previous slide" class="arrow-control prev datalayer-link" tabindex="0"><i class="icon icon-arrow-thin-left"></i></a></div>');
                        $('#site-nav-vehicles-previuos-tab').on('keyup', onPrevSlideKeyUp.bind(this));
                      }
                      if (!($('#site-nav-vehicles-next-tab').length > 0)) {
                        $('.site-nav-vehicles-wrap div.bx-wrapper').after('<div class="bx-carousel-controls" id="site-nav-vehicles-next-tab"><a data-linktext="next" aria-label="next slide" class="arrow-control next datalayer-link" tabindex="0"><i class="icon icon-arrow-thin-right"></i></a></div>');
                        $('#site-nav-vehicles-next-tab').on('keyup', onNextSlideKeyUp.bind(this));
                      }
                      // trigger an event on navEL
                      updateActive(0, slider.getSlideCount());
                    }, 0);
                  },
                  onSlideBefore: function ($slideEl, oldIdx, newIdx) {
                    updateActive(newIdx, slider.getSlideCount());
                    $(nav).trigger('loadimages', { $scope: $slideEl });
                  },
                });
                $this.find('.arrow-control.next').on('click', function (e) {
                  e.preventDefault();
                  slider.goToNextSlide();
                });
                $this.find('.arrow-control.prev').on('click', function (e) {
                  e.preventDefault();
                  slider.goToPrevSlide();
                });

                $this.on('navigationexpanded', function () {
                  if (needsReload) {
                    slider.reloadSlider();
                    $(nav).trigger('loadimages', { $scope: slider.getCurrentSlideElement() });
                    needsReload = false;
                  }
                });
              });
            } else if (ContainerMode === renderMode) {
              $el = $(nav.renderInContext(__tmplContainer, {
                isMobile: $el.closest('.site-nav-mobile-cta').length > 0,
                link: link,
                categoryLinks: categoryLinks
              })).replaceAll($el);

              categoryLinks.map(function (cat) {
                $('[data-linkid="' + cat.id + '"]', $el).each(function () {
                  var $this = $(this);
                  $this.on('navigationexpanding', function () {
                    $(nav).trigger('loadimages', { $scope: $this });
                  });
                });
              });
            }

            // Inject disclaimers
            // TODO: Determine a better way to do this
            $(function () {
              // BAT-3935: Have to wait until dom is fully ready otherwise disclaimer service breaks.
              disclaimers.msrpMpgDigits('li[data-linkid="' + $el.data('linkid') + '"]', true);
            });
          });

          PageCache.await(compareCacheId)
            .then(function (compareUrls) {
              if (CompareSource === 'off') {
                $('.series-action-compare', nav.$el).hide();
                $('.site-nav-vehicles-series-info').find('.pipe').hide();
              } else {
                $('.series-action-compare', nav.$el).each(function () {
                  var $this = $(this);
                  var key = [$this.data('series-year'), $this.data('series-code')].join('-');
                  var url = compareUrls[key];

                  if (url) {
                    $this.attr('href', url);
                  }
                });
              }
            });
        });
    },
    // BAT-4777 keyboard navigation for "SEE OFFERS” and “COMPARE” links
    onMenuKeyDown: function (nav, event) {
      if (event && nav && (event.keyCode === 13 || event.keyCode === 32)) {
        if (!$(event.target).is(nav.__selContainerExpanded)) {
          $('.site-nav-link-type-vehicles').addClass('keyboard-expanded');
        }
      }
    },
    onNavigationCollapsed: function (nav, event) {
      if (event && nav) {
        $('.site-nav-link-type-vehicles').removeClass('keyboard-expanded');
      }
    }
  });

  VehiclesPlugin.defaults = {
    assetUrlPrefix: '',
    disabledCategories: ['cars'],
    carouselRegions: ['primary'],
  };

  Navigation.registerPlugin(VehiclesPlugin);

  Navigation.registerLinkTypeRenderer('vehicles', function (context, opt) {
    return __tmplLoader(context, opt);
  });

  Navigation.registerLinkTypeRenderer('series', txtSeries);
});

